import { createSelector } from "@reduxjs/toolkit";
import { RootStateOrAny } from "react-redux";
import { TopBarState } from "./types";

export const topBarSelector = createSelector(
  (state: RootStateOrAny) => state.topBar,
  (state: TopBarState) => state
);
